import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-order-manager',
    templateUrl: './order-manager.component.html',
    styleUrls: ['./order-manager.component.css'],
    standalone: false
})
export class OrderManagerComponent  implements OnInit{

  isApprovalsVisable: boolean;
  protected readonly sessionStorage = sessionStorage;
  otcRoutes: string[] = ['my-order', 'approvales', 'approved-orders'];

  constructor(protected router: Router, private route: ActivatedRoute) {
    // router.
  }
  ngOnInit(): void {

    let roleCheck = sessionStorage.getItem('roles');
    if (roleCheck.includes('OTCAgent') || roleCheck.includes('OTCRepresentative')) {
      this.isApprovalsVisable = false;
    } else{
      this.isApprovalsVisable = true;
    }
  }

}
